import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deletePlanAndRateOverrideRulesByFilter } from '../../../api/plan-and-rate-override-rules-api'
import type {
  DeletePlanAndRateOverrideRulesByFilterRequestDto,
  DeletePlanAndRateOverrideRulesByFilterResponseDto,
} from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

export function useDeletePlanAndRateOverrideRulesByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    DeletePlanAndRateOverrideRulesByFilterResponseDto,
    unknown,
    DeletePlanAndRateOverrideRulesByFilterRequestDto
  >({
    mutationFn: (params) => deletePlanAndRateOverrideRulesByFilter(params),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
